import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'

const LEVERAGE_ROWS = [
  { type: 'FX Majors', leverage: 'Up to 1:1000' },
  { type: 'FX Minors', leverage: 'Up to 1:1000' },
  { type: 'FX Exotics', leverage: 'Up to 1:100' },
  { type: 'Precious Metals', leverage: 'Up to 1:1000' },
  { type: 'Energies', leverage: 'Fixed at 1:400' },
  { type: 'Cryptocurrencies', leverage: 'Fixed at 1:200' },
  { type: 'Indices', leverage: 'Fixed at 1:500' },
]

export default function Leverage() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xlv-wrap { overflow-x: auto; border: 1px solid ${C.bdr}; border-radius: 12px; }
        .xlv-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 420px; }
        .xlv-table th, .xlv-table td { padding: 12px 16px; border-bottom: 1px solid ${C.bdr}; text-align: left; }
        .xlv-table th { color: ${C.tx}; font-family: ${fOutfit}; font-weight: 700; }
        .xlv-table td { color: ${C.tx2}; }
      `}</style>
      <PublicNav active="Trading" />

      <section style={{ padding: '130px 24px 50px', textAlign: 'center', borderBottom: `1px solid ${C.bdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Trading Conditions</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 12px', color: C.tx }}>Leverage up to 1:1000</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, maxWidth: '560px', margin: '0 auto' }}>Fixed leverage per asset class gives you predictable margin requirements no matter how your account balance changes.</p>
      </section>

      <section style={{ padding: '60px 24px', maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 24px', color: C.tx }}>Leverage Per Asset Class</h2>
        <div className="xlv-wrap">
          <table className="xlv-table">
            <thead><tr><th>Asset Class</th><th>Leverage</th></tr></thead>
            <tbody>
              {LEVERAGE_ROWS.map(r => <tr key={r.type}><td>{r.type}</td><td>{r.leverage}</td></tr>)}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '32px', fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.5 }}>
          <p>Leverage is fixed per asset class rather than scaling with your account balance. This keeps margin requirements predictable as your equity changes — opening or closing positions recalculates margin only for the affected trade, not your whole account.</p>
          <p>For example, with a fixed leverage of 1:1000 on gold, a margin requirement of $300 per lot stays $300 per lot whether your account holds $10,000 or $100,000, unless you choose to reduce your effective leverage manually.</p>
          <p>You can lower your effective leverage at any time from your account settings by sizing positions more conservatively. Xperia Capital also reserves the right to apply a reduced maximum leverage where required by risk management or regulation.</p>
        </div>

        <p style={{ fontSize: '11px', color: C.tx3, marginTop: '24px' }}>
          Terms and conditions apply. For full details on how leverage is applied and managed, refer to our <a href="#" style={{ color: C.tx2, textDecoration: 'underline' }}>Risk Disclosure</a>. In the event of any discrepancy, Xperia Capital's interpretation shall prevail.
        </p>

        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <Link to="/signup" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '11px 28px', borderRadius: '999px', textDecoration: 'none' }}>Sign Up</Link>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
